/*! basic-main */

$(document).ready(function () {

    // Bootstrap tooltips
    $('[data-toggle="tooltip"]').tooltip();
});

// IsMobile() Returns true if window up to 800px wide
//
var mBreakpoint = "(min-width: 801px)";
function IsMobile() {
    var mq = window.matchMedia(mBreakpoint);
    return !mq.matches;
}



function PutElementIntoView($target) {
    var floatingHeaderHeight = 0;
    if (IsMobile()) {
        $('.sticky:visible').each(function (index, element) {
            floatingHeaderHeight += $(this).outerHeight();
        });
    } else {
        floatingHeaderHeight += $('.site-nav-desktop').outerHeight();
        floatingHeaderHeight += $('header').outerHeight();
    }

    var viewTop = $(window).scrollTop();
    var elementOffset = $target.offset().top - (viewTop + floatingHeaderHeight);
    if (elementOffset < 0) {
        $(window).scrollTop(viewTop + elementOffset);
    }
}